import React from 'react';
import { Redirect } from "react-router";
import PropTypes from 'prop-types';
import { Route, Switch, withRouter } from 'react-router-dom';
import { Layout, PageHeader } from '../../common/components';
import {  CreatePage, ListView, EditPage} from './page';
import { hasRights, rights } from "../../common/utils/role-right-helper";

const UserHeader = (
  <PageHeader title="User Settings" />
)

const User = ({ match }) => {
  if(!hasRights([rights.CanViewUsers]))
    return (<Redirect to="/" />);

  return (
    <Layout PageHeader={UserHeader}>
      <Switch>
        <Route exact path={`${match.url}`} component={ListView} />
        <Route exact path={`${match.url}/create`} component={CreatePage} />
        <Route exact path={`${match.url}/:id`} component={EditPage} />
      
      </Switch>
    </Layout>
  );
}

User.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string,
  }),
};

User.defaultProps = {
  match: {
    url: '',
  },
};

export default withRouter(User);
